import { SubscribeConsumerEventData } from './consumer';

export function Consumes(args?: string | { context?: string; elementAttribute?: string }) {
  return (target: any, propertyKey: string): void => {
    const context = typeof args === 'string' ? args : args?.context;
    const elementAttribute = typeof args === 'string' ? 'el' : args?.elementAttribute || 'el';
    const contextKey = context ?? propertyKey;

    const { componentWillLoad, connectedCallback, disconnectedCallback } = target;

    target.__syContextConsumesKeys = target.__syContextConsumesKeys || [];
    if (!target.__syContextConsumesKeys.find((el) => el.contextKey === contextKey)) {
      target.__syContextConsumesKeys.push({ contextKey, propertyKey });
    }

    target.__syContextConsumesMount = function () {
      const element = this[elementAttribute];
      if (!element) {
        throw `@Consumes decorators requires '@Element' to be defined in the component ("${this?.constructor?.name}"). The @Element attribute name is, by default, 'el'. You can change it with a parameter in @Consumes decorator.`;
      }

      this.__syContextConsumesElements = this.__syContextConsumesElements || {};

      this.__syContextConsumesKeys.forEach((key) => {
        if (!this.__syContextConsumesElements[key.contextKey]) {
          this.__syContextConsumesElements[key.contextKey] = {
            key,
            changeValue: (newValue) => {
              this[key.propertyKey] = newValue;
            },
          };
        }
      });

      this.__syContextConsumesKeys.forEach((key) => {
        element?.dispatchEvent(
          new CustomEvent<SubscribeConsumerEventData>('syContextConsumerDidSubscribe', {
            detail: {
              context: key.contextKey,
              el: this.__syContextConsumesElements[key.contextKey],
            },
            bubbles: true,
            composed: true,
          }),
        );
      });
    };

    if (!target.__syContextConsumesWrapped) {
      target.__syContextConsumesWrapped = true;
      target.componentWillLoad = async function () {
        const hookReturn = componentWillLoad?.call(this);
        this.__syContextConsumesMount();
        return hookReturn;
      };
      target.connectedCallback = async function () {
        const hookReturn = connectedCallback?.call(this);
        this.__syContextConsumesMount();
        return hookReturn;
      };
      target.disconnectedCallback = async function () {
        const hookReturn = disconnectedCallback?.call(this);
        this.__syContextConsumesKeys.forEach((key) => {
          if (this.__syContextConsumesElements[key.contextKey]?.unsubscribe) {
            this.__syContextConsumesElements[key.contextKey]?.unsubscribe();
          }
        });

        return hookReturn;
      };
    }
  };
}
